import { useNavigate, useParams } from "react-router-dom";
import { RoutedModal } from "../../../../components/common";
import { pathConstants } from "../../../../routes/pathContants";
import secondaryComponents from "../../../../components/secondaryComponents";
import primaryComponents from "../../../../components/primaryComponents";
import { useEffect } from "react";
import { PlusIcon } from "../../../../assets/svgIcons";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import useExpenses from "../../../appPages/Expenses/Expenses/useExpenses";

export const SMExpenseHome = () => {
  const navigate = useNavigate();
  const { store_id } = useParams();
  const {
    isFetchingExpenses,
    metaDetails,
    search,
    expenses,
    isCreateExpense,
    filterByStoreId,
    setIsCreateExpense,
    handleFetchExpenses,
    gotoPage,
    searchExpenses,
  } = useExpenses();

  useEffect(() => {
    if (!search.get("store_id")) filterByStoreId(store_id);
  }, []);

  return (
    <RoutedModal
      isActive={true}
      headerTitle="Expenses"
      headerDescription="Create, track and manage all your expenses in one place"
      closeModal={() =>
        navigate(pathConstants.SELL_MODE({ store_id: store_id }))
      }
    >
      <secondaryComponents.NavigateWithPermission
        permissionParentKey={"Expense"}
        permissionChildKey="can_create_expense"
      >
        <primaryComponents.Button
          classNames="btn btn--primary ml-auto"
          onClick={() => setIsCreateExpense(true)}
        >
          <PlusIcon style={{ fontSize: "20px" }} className="mr-1" />
          Create Expense
        </primaryComponents.Button>
      </secondaryComponents.NavigateWithPermission>

      <section className={`${globalStyles.cardWithBorder} overflow-hidden p-0`}>
        <div className={globalStyles.tableHeader}>
          <primaryComponents.SearchField
            classNames={globalStyles.searchField}
            placeholder="Search for expenses"
            trigger={(value) => searchExpenses(value)}
            value={search.get("query") !== null ? search.get("query") : ""}
            triggerOnInput={true}
            showsearchBtn={true}
          />
        </div>

        <secondaryComponents.LoaderHelper
          isLoading={isFetchingExpenses}
          classNames="my-5"
        >
          <secondaryComponents.ExpensesTable
            metaDetails={metaDetails}
            expenses={expenses}
            handleFetchExpenses={handleFetchExpenses}
            gotoPage={gotoPage}
            isViaSellMode={true}
          />
        </secondaryComponents.LoaderHelper>
      </section>

      <secondaryComponents.SideModal
        width={550}
        isActive={isCreateExpense}
        closeModal={() => setIsCreateExpense(false)}
      >
        <secondaryComponents.CreateExpense
          closeWidget={() => setIsCreateExpense(false)}
        />
      </secondaryComponents.SideModal>
    </RoutedModal>
  );
};
